import React from 'react';
import adZones from '../../data/adZones';
import { FaithlifeAd } from '../../components/faithlife-ad';
import { Suggestion, ISuggestion } from './suggestion';
import './index.less';

interface IEndCapProps {
	suggestedVideoEndcap: {
		suggestions: ISuggestion[];
		header: string;
	};
	adParams?: object;
}

interface IEndCapState {
	active: string;
}

const activeEndCapClass = 'endcap-active';
const inactiveEndCapClass = 'endcap-inactive';
const maxEndCapSuggestions = 2;

export class EndCap extends React.Component<IEndCapProps, IEndCapState> {
	state: IEndCapState = {
		active: activeEndCapClass,
	};

	_handleCloseButton = () => {
		if (this.state.active === activeEndCapClass) {
			this.setState({ active: inactiveEndCapClass });
		}
	};

	render() {
		const { suggestedVideoEndcap, adParams } = this.props;
		const { active } = this.state;

		let suggestions;
		const faithlifeAds: JSX.Element[] = [];
		const fullLayoutSuggestion = suggestedVideoEndcap.suggestions.find(suggestion => suggestion.layout === 'full');
		if (fullLayoutSuggestion) {
			suggestions = [fullLayoutSuggestion];
		} else {
			suggestions = suggestedVideoEndcap.suggestions;
			for (let i = 0; i < maxEndCapSuggestions - suggestions.length; i++) {
				faithlifeAds.push(<FaithlifeAd key={i} zone={adZones[i]} params={adParams} />);
				// TODO: Don't rely on there always being 2 adzones and 2 endcap items
			}
		}

		return (
			<div className="end-cap">
				<aside className={active}>
					{/* TODO: Fix this the next time the file is edited. */}
					{/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
					<div className="close-button" onClick={this._handleCloseButton}>
						&#x2A09;
					</div>
					<h5 className="header">{suggestedVideoEndcap.header}</h5>
					<div className="container">
						{suggestions.map(suggestion => (
							<Suggestion key={suggestion.title} suggestion={suggestion} />
						))}
						{faithlifeAds.length ? faithlifeAds : false}
					</div>
				</aside>
			</div>
		);
	}
}
